export enum IOrganisationTab {
    contractArea,
    clinic,
    roleGroup
}

export interface IOrganisation {
    organisationId: number;
    name: string;
    organisationNumber: string;
    hsaId: string;
    counterPartId: number;
    sectorId: number;
    raindanceSupplierNumber: string;
    accountNumber?: string;
    gdprAcceptedByName?: string;
    expectCancelledInvoiceMail?: boolean;
    regBy: number;
    updBy?: number;
    contractAddressPostalAddressId: number;
    contractAddressContactName?: string;
    contractAddressAddress: string;
    contractAddressZipCode: string;
    contractAddressCity: string;
    contractAddressPhoneNumber?: string;
    contractAddressAlternativePhoneNumber?: string;
    contractAddressEmailAddress?: string;
}